import React from 'react';
import { Handle, Position } from 'reactflow';
import { Clock } from 'lucide-react';
import NodeActionButtons from "./NodeActionButtons";

const DelayNode = ({ id, data }) => {
  const getDurationText = () => {
    const duration = data.duration || 5;
    const unit = data.unit || 'seconds';
    return `Wait ${duration} ${unit}`;
  };

  return (
    <div className="relative bg-orange-100 border-2 border-orange-400 rounded-lg p-4 min-w-[200px]">
      <NodeActionButtons id={id} data={data} />
      <Handle 
        type="target" 
        position={Position.Left} 
        className="!w-4 !h-4 !bg-orange-500 !border-2 !border-white"
        style={{ left: -8 }}
      />
      <div className="flex items-center gap-2 mb-2">
        <Clock size={20} className="text-orange-600" />
        <div className="font-semibold text-orange-900">Delay</div>
      </div>
      <div className="text-sm text-orange-700">
        {getDurationText()}
      </div>
      <Handle 
        type="source" 
        position={Position.Right} 
        className="!w-4 !h-4 !bg-orange-500 !border-2 !border-white"
        style={{ right: -8 }}
      />
    </div>
  );
};

export default DelayNode;
